import React from "react";
import { Ruler } from "lucide-react";
import { BANNER_MAX_SIZE_MB, formatDimensionGuide } from "../../utils/storeDefaults";

const DimensionGuide = ({ guide, compact = false }) => {
  if (!guide) return null;

  if (compact) {
    return (
      <p className="text-[11px] text-gray-500">
        Recommended: <span className="font-medium text-gray-700">{formatDimensionGuide(guide)}</span>
        {" · "}
        Max {BANNER_MAX_SIZE_MB}MB
      </p>
    );
  }

  return (
    <div className="p-3 rounded-xl border border-blue-100 bg-blue-50/60">
      <div className="flex items-start gap-2.5">
        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-white text-blue-600 shrink-0">
          <Ruler className="w-4 h-4" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold text-gray-800">{guide.label} dimensions</p>
          <dl className="grid grid-cols-2 gap-x-4 gap-y-1 mt-2 text-[11px]">
            <div>
              <dt className="text-gray-400">Recommended</dt>
              <dd className="font-medium text-gray-800">
                {guide.width} × {guide.height} px
              </dd>
            </div>
            <div>
              <dt className="text-gray-400">Aspect ratio</dt>
              <dd className="font-medium text-gray-800">
                {guide.ratio} · {guide.ratioDescription}
              </dd>
            </div>
            <div>
              <dt className="text-gray-400">Minimum width</dt>
              <dd className="font-medium text-gray-800">{guide.minWidth} px</dd>
            </div>
            <div>
              <dt className="text-gray-400">File types</dt>
              <dd className="font-medium text-gray-800">
                {guide.formats} · max {BANNER_MAX_SIZE_MB}MB
              </dd>
            </div>
          </dl>
          {guide.tip ? (
            <p className="mt-2 text-[11px] leading-relaxed text-blue-800/80">{guide.tip}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DimensionGuide;
